// ---------------------------------------------------------
// JS dependencies
// ---------------------------------------------------------
import 'bootstrap/dist/js/bootstrap.js';
import '@fortawesome/fontawesome-free/js/all.js';
import 'select2/dist/js/select2.js';
import 'jquery-ui-dist/jquery-ui.js';
import 'jquery-number';
import 'eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker.js';
import 'intl-tel-input/build/js/intlTelInput.js';
import 'cleave.js/dist/cleave.js';
import 'js-cookie/src/js.cookie.js';

// ---------------------------------------------------------
// JS dependencies
// ---------------------------------------------------------
import "core-js/stable";
import 'core-js/features/promise'; 
import "regenerator-runtime/runtime";

import './js/main.js';
import './js/scrolls.js';
import './js/carousels.js';
import './js/forms.js';
import './js/summary.js';
import './js/welcome.js';


// ---------------------------------------------------------
// CSS dependencies
// ---------------------------------------------------------
import './css/style.scss';

const mobileWidth = 991;